<div>
    <ValidatedRadioButtonGroup [label]="'Enrollment Method'"
                               [options]="EnrollmentMethodOptions"
                               [selectedValue]="methodOption"
                               [radioGroupName]="EnrollmentMethodOptions"
                               (onValueChange)="EnrollmentMethodChange($event)"
                               [validators]="[notBlankValidator]">
    </ValidatedRadioButtonGroup>
</div>
<div *ngIf="this.methodOption=== 'APPPORTAL'">
    <strong>YOUR CLIENT SIGNATURE IS REQUIRED. After you complete the online enrollment, please print out the document and have your client sign it</strong>
</div>
<br />
<div>

    <ValidatedRadioButtonGroup [label]="'Scope of Appointment'"
                               [options]="SoaOptions"
                               [selectedValue]="soaComplete"
                               [radioGroupName]="SoaOptions"
                               (onValueChange)="isSoaCompleteChange($event)"
                                [validators]="[notBlankValidator]">
    </ValidatedRadioButtonGroup>
</div>

<br />
<div>
    <button class="button primary" (click)="validateForm()">Continue</button>
    <!--<button style="background-color:red" onclick="validateForm">Continue</button>-->
</div>
<br />